import EventBus from "./event-bus";
import { base_url, EVENTS } from "./constants";
import TrackingService from "./tracking-service";
import DataStore from '../services/data-store'

export default {
	install,
	isInAdmin,
    checkManifestIcon,
};

init();

function init() {
	// im not sure its true. maybe we just needed an external link; check if when loaded later it shows prmopt

	// required to have a valid manifest already on page load
	// else, the beforeinstallprompt is not fired on android.
	// https://stackoverflow.com/questions/58806430/pwa-install-prompt-when-setting-manifest-dynamically
	installServiceWorker(null);
	captureInstallPrompt();
	EventBus.$on(EVENTS.shopChanged, shop => {
		// return;
		installServiceWorker(shop).then(() => updateManifest(shop));
	});
	window.addEventListener("appinstalled", () => {
		// hide banner
		EventBus.$emit(EVENTS.canInstall, false);
		// user can install not always from deferredPrompt
		TrackingService.track("CompleteRegistration", {
			content_name: "Install",
			status: true,
			// content_name, currency, status, value
		});
	});
}

function install() {
	deferredPrompt.prompt();
	// Wait for the user to respond to the prompt
	deferredPrompt.userChoice.then(choiceResult => {
		console.log(choiceResult);
		if (choiceResult.outcome === "accepted") {
			console.log("User accepted the A2HS prompt");
		} else {
			console.log("User dismissed the A2HS prompt");
		}
		deferredPrompt = null;
	});
}

let deferredPrompt = null;
function captureInstallPrompt() {
	window.addEventListener("beforeinstallprompt", e => {
		console.log("beforeinstallprompt called");
		// return;
		// Prevent Chrome 67 and earlier from automatically showing the prompt
		// e.preventDefault();
		// Stash the event so it can be triggered later.
		deferredPrompt = e;
		updateCanInstall();
	});
}

function checkManifestIcon(url) {
    let resolver, rejecter;
    let p = new Promise((resolve, reject) => {
        resolver = resolve;
        rejecter = reject;
    });
    let img = new Image();
    img.onload = () => {
        resolver({
            width: img.width,
            height: img.height,
        });
        DataStore.notifyAngularJs();
    };
    img.onerror = () => {
        rejecter('Logo introuvable');
        DataStore.notifyAngularJs();
    };
    img.src = url;
    return p.then(icon_size => {
        let size = `${icon_size.width} x ${icon_size.height} px`;
        if (icon_size.width < 144) {
            return Promise.reject(`Icone trop petite: ${size} (Taille min: 144px)`);
        }
        if (icon_size.width != icon_size.height) {
            return Promise.reject(`Icone non carrée: ${size}`);
        }
    });
}

function isInAdmin() {
	return location.href.indexOf("admin") != -1;
}

function installServiceWorker(shop) {
	if ("serviceWorker" in navigator) {
		return navigator.serviceWorker
			.register("./service-worker.js", { scope: isInAdmin() ? "admin2/" : shop?.ShopId || "" })
			.then(function (registration) {
				// Registration was successful
				console.log("ServiceWorker registration successful with scope: ", registration.scope);
			})
			.catch(function (err) {
				// registration failed :(
				console.log("ServiceWorker registration failed: ", err);
			});
	}
	return Promise.reject("serviceworker not in navigator");
}

function updateCanInstall() {
	let alreadyInstalled = window.matchMedia("(display-mode:standalone)").matches;
	if (deferredPrompt && !alreadyInstalled) {
		EventBus.$emit(EVENTS.canInstall, true);
		console.log('emit canInstall',true)
	}
}

function updateManifest(shop) {
	if (!window.manifest) {
		return;
	}
	let url = `${base_url}/admin/shop/manifest?ShopId=${shop.ShopId}&admin=${isInAdmin() ? 1 : 0}`;
	window.manifest.setAttribute("href", url);

    let manifest_url = window.manifest.href;
    fetch(manifest_url)
    .then(res => res.json())
    .then(json => checkManifestIcon(json.icons[0].src))
	.then(() => updateCanInstall())
	.catch(msg => console.error(msg));
}
